import { DataServiceModule } from './data.service';

export const TermsAndConditionsServiceModule = angular
    .module('app.services.data.termsAndConditionsService', [
        DataServiceModule
    ]).service('termsAndConditionsService', (
        dataService,
        settings
    ) => {
        return {
            getTerms,
            getAcceptedTermsById,
            acceptTerms
        };

        function getTerms() {
            return dataService.get(settings.api.terms);
        }

        function getAcceptedTermsById(termsId) {
            return dataService.get(settings.api.acceptedTerms, termsId);
        }

        function acceptTerms(termsId, acceptedBy) {
            return dataService.create(settings.api.acceptedTerms, { termsId, acceptedBy });
        }
    }).name;



// WEBPACK FOOTER //
// ./src/app/services/data/termsAndConditions.service.js